import { render } from "./App.vue?vue&type=template&id=1eb37504"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1eb37504&lang=css"

import exportComponent from "C:\\Users\\yojan\\Documents\\Adlightech\\Development\\Contact-leads2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__